module.exports = __webpack_public_path__ + "static/media/info-icon.5787166e.svg";